import { useEffect, lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { login, logout } from "./redux/slices/userSlice";
import Loader from "./components/Loader/Loader";
const Auth = lazy(() => import("./pages/Auth/Auth"));
const Home = lazy(() => import("./pages/Home/Home"));
const Register = lazy(() => import("./pages/Auth/Register"));
const Mainpage = lazy(() => import("./pages/mainPage/Mainpage"));

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo.isLoggedIn) {
      dispatch(login(userInfo.user));
      if (
        window.location.pathname === "/auth" ||
        window.location.pathname === "/register"
      ) {
        navigate("/");
      }
    } else {
      localStorage.removeItem("persist:root");
      localStorage.removeItem("token");
      dispatch(logout());
      if (window.location.pathname !== "/register") {
        navigate("/auth");
      }
    }
  }, []);
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/register" element={<Register />} />
        <Route path="/feed" element={<Mainpage />} />
      </Routes>
    </Suspense>
  );
};

export default ProtectedRoute;
